import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2, ArrowRight } from "lucide-react";
import useSeo from "@/hooks/useSeo";

export default function VerifyEmail() {
  useSeo({ title: "Verifica email", path: "/verify-email", noindex: true });
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Token mancante nel link. Richiedi un nuovo invio dalla dashboard");
      return;
    }
    (async () => {
      try {
        await api.post("/auth/verify-email/confirm", { token });
        setStatus("ok");
      } catch (e) {
        setStatus("error");
        setMessage(e?.response?.data?.detail || "Link non valido o gi\u00e0 usato");
      }
    })();
  }, [params]);

  return (
    <div className="min-h-screen bg-[#FAF9F6] grid place-items-center p-6" data-testid="verify-email-page">
      <div className="w-full max-w-md rounded-2xl border border-[#E8E4D9] bg-white p-8 text-center">
        <div className="mb-4 inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-[#1D4ED8] font-bold">
          <span className="w-6 h-px bg-[#1D4ED8]" /> Verifica email
        </div>

        {status === "loading" && (
          <>
            <Loader2 className="w-10 h-10 mx-auto text-zinc-400 animate-spin" />
            <h1 className="mt-4 font-display font-extrabold text-2xl">Sto verificando il tuo indirizzo</h1>
            <p className="mt-2 text-sm text-zinc-600">Un attimo di pazienza</p>
          </>
        )}

        {status === "ok" && (
          <>
            <div className="mx-auto w-14 h-14 rounded-full bg-emerald-50 grid place-items-center">
              <CheckCircle2 className="w-7 h-7 text-emerald-600" />
            </div>
            <h1 className="mt-4 font-display font-extrabold text-2xl">Email verificata</h1>
            <p className="mt-2 text-sm text-zinc-600">Il tuo account &egrave; ora completamente attivo</p>
            <Link
              to="/app"
              data-testid="verify-email-continue"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#0A0A0A] text-white text-sm font-semibold hover:bg-[#1D4ED8] transition-colors"
            >
              Vai alla dashboard <ArrowRight className="w-4 h-4" />
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <div className="mx-auto w-14 h-14 rounded-full bg-red-50 grid place-items-center">
              <XCircle className="w-7 h-7 text-red-600" />
            </div>
            <h1 className="mt-4 font-display font-extrabold text-2xl">Link non valido</h1>
            <p className="mt-2 text-sm text-zinc-600">{message}</p>
            <Link
              to="/app"
              data-testid="verify-email-return"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#0A0A0A] text-white text-sm font-semibold hover:bg-[#1D4ED8] transition-colors"
            >
              Torna alla dashboard <ArrowRight className="w-4 h-4" />
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
